import { useEffect, useState } from 'react';
import * as S from './RadioButton.styles';
import { RadioButtonProps } from './radio.interface';

const RadioButton = ({ items, defaultValue, onChange }: RadioButtonProps) => {
  const handleChange = (value: any) => {
    setValue(value);
    onChange(value);
  };
  const [value, setValue] = useState<string>();

  useEffect(() => {
    const defaultSelectedItem = items.find((e) => e.checked || e.value === defaultValue);
    setValue((defaultSelectedItem && defaultSelectedItem.value) || items[0].value);
  }, [items, defaultValue]);

  return (
    <S.Wrapper>
      <S.RadioGroup>
        {items.map((item) => (
          <S.RadioWrapper $checked={item.value === value} key={item.value} onClick={() => handleChange(item.value)}>
            <S.Radio $checked={item.value === value} />
            <S.Label>{item.title}</S.Label>
          </S.RadioWrapper>
        ))}
      </S.RadioGroup>
    </S.Wrapper>
  );
};

export default RadioButton;
